/**
 * Orders wire types: zod schemas, with the types inferred from them.
 *
 * These describe what crosses the network. Database row types live in the
 * module schema and are deliberately not re-exported.
 */
import { messageRefSchema } from '@daka/core';
import { z } from 'zod';

import { ORDER_STATUSES } from './lifecycle';
import { orderRowSchema } from './schemas';

const orderSchema = z
   .object({
      id: z.uuid(),
      filename: z.string(),
      objectKey: z.string().nullable(),
      /** Open spreadsheet staging (`imports.id`); null once lines are materialized. */
      stagingImportId: z.uuid().nullable(),
      status: z.enum(ORDER_STATUSES),
      submitError: messageRefSchema.nullable(),
      lineCount: z.number().int(),
      /** Materialized lines that fail the contract; staging uses import `invalidCount` on the FE. */
      invalidLineCount: z.number().int(),
      createdAt: z.iso.datetime(),
      updatedAt: z.iso.datetime()
   })
   .readonly();
export type Order = z.infer<typeof orderSchema>;

const orderLineSchema = orderRowSchema.extend({ id: z.uuid(), rowNumber: z.number().int() }).readonly();
export type OrderLine = z.infer<typeof orderLineSchema>;
